// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-recommendations-dom').RecommendationStatusBar

      resolve(View)

    /* Webpack named bundle   */
    }, 'recommendationStatusBar')
  })
}

export default asyncRoute({getComponent, reducers: []})
